import NewTeamFormModal from './NewTeamFormModal.container';

export default NewTeamFormModal;
